import { render, staticRenderFns } from "./LoadPhotographies.vue?vue&type=template&id=3082fab6&scoped=true"
import script from "./LoadPhotographies.vue?vue&type=script&lang=js"
export * from "./LoadPhotographies.vue?vue&type=script&lang=js"
import style0 from "./LoadPhotographies.vue?vue&type=style&index=0&id=3082fab6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082fab6",
  null
  
)

export default component.exports